import { action } from 'satcheljs/lib/legacy';
import { FeedbackViewState } from '../store/schema/FeedbackViewState';

export default action('clearFeedback')(function clearFeedback(state: FeedbackViewState) {
    state.selectedFeedbackArea = null;
    state.subject = '';
    state.isIncludeDebugInfoChecked = true;
    state.message = '';
    state.classification = null;
    state.screenshotBlob = null;
    state.screenshotFileBase64 = null;
});
